import { combineReducers } from "redux";
import { keycloakReducer as keycloak } from "@authzsvc/keycloak-js-react";

import groups from "./groups";
import loading from "./loading";
import groupMembership from "./groupMembership";
import identity from "./identity";
import identityAccounts from "./identityAccounts";
import groupMemberIdentities from "./groupMemberIdentities";
import groupMemberGroups from "./groupMemberGroups";
import groupScope from "./groupScope";
import requests from "./requests";
import sidebar from "./sidebar";

const rootReducer = combineReducers({
  keycloak,
  groupScope,
  groupMemberGroups,
  groupMemberIdentities,
  identity,
  identityAccounts,
  groupMembership,
  requests,
  groups,
  loading,
  sidebar,
});

export default rootReducer;
